import { h, Component } from 'preact';
import pure from 'utils/pure';
import Store from "store/store.js";
import * as actions from "store/actions.js";
import s from 'components/shared/orientationPrompt/orientationPrompt.sss';
import { joinClasses } from 'utils/utils';

export default @pure class OrientationPrompt extends Component {

	// RENDER METHODS
	// -------------------------------------------
	render(props) {
		const {
			overlayOrientation,
			client
		} = props;

		let showOverlay = false;
		let screenOrientation = null;
		if (typeof global.window !== 'undefined' && window.screen && overlayOrientation) {
			const screen = window.screen;

			// removed screen.mozOrientation to prevent overlay to display on Firefox mobile simulator
			screenOrientation = screen.msOrientation || (screen.orientation || {}).type;

			let currentOrientation = 'portrait';
			// adding this extra condition to fix Google Mobile Friendly Test bug where their window.screen.orientation.type was saying it was landscape when it was clearly not
			const landscapeFromDimensions = window.innerWidth > window.innerHeight;
			if (landscapeFromDimensions && (screenOrientation ? screenOrientation.startsWith('landscape') : Math.abs(window.orientation) === 90)) {
				currentOrientation = 'landscape';
			}

			const { deviceSize, isTouch, disableOrientationPrompt } = client;
			const isMobile = deviceSize == 'mobile' && isTouch;
			showOverlay = !disableOrientationPrompt && isMobile && currentOrientation !== overlayOrientation;
			if (showOverlay !== this.lastShowOverlay) {
				this.lastShowOverlay = showOverlay;
				Store.emit(showOverlay ? actions.SCROLL_LOCK : actions.SCROLL_UNLOCK);
			}
		}

		if (!showOverlay) {
			return <div class={props.baseClass} key="overlay" />;
		}
		return <div class={joinClasses(s.overlay, props.class, props.baseClass)} key="overlay" />;
	}

}
